import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {EntityDescriptionFactory} from "./entity-description.factory";
import {EntityDescriptionApiService} from "./entity-description.api-service";

export class EntityDescriptionRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, EntityDescriptionApiService, EntityDescriptionFactory];
}
